const constants = {
  ASSET_BASE_URL: 'https://assets.pjsek.ai/file/pjsekai-assets/',
  API_BASE_URL: 'https://api.pjsek.ai/',
  OFFICIAL_NOTICE_BASE_URL: 'https://production-web.sekai.colorfulpalette.org/',
  HONOR_RARITIES: {
    low: 1,
    middle: 2,
    high: 3,
    highest: 4,
  },
};

export default constants;